import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { REPORT_UID_PATTERN } from "@constants/url-parameter-patterns";

type GetReportLinkRequestResponse = {
    url: string;
};

export const getReportLinkRequest = async (
    reportUid: string
): Promise<GenericNetworkResponse<GetReportLinkRequestResponse>> => {
    const url = injectCustomIdParameter(apiRoutes.reports.report.link, reportUid, REPORT_UID_PATTERN);
    const { data, error } = await handleRequest(RequestTypes.GET, url);
    return { data, error };
};